// Internal action types
import { WINDOW_AVAILABLE } from '../redux/app';
import { ROUTER_LOCATION_CHANGED } from '../redux/route';
import {
  LOG_IN_SUCCEEDED,
  LOG_OUT_REQUESTED,
  RESET_PASSWORD_SUCCEEDED,
  SIGN_UP_SUCCEEDED,
} from '../redux/account';

import { DEEP_LINK_CLICKED } from '../redux/deepLinks';
import { EMAIL_DESIGN_REQUESTED } from '../redux/emailDesign';
import { NEW_SUCCEEDED, SEND_SUCCEEDED } from '../redux/event';
import { ADD_FAVORITE_SUCCESS } from '../redux/favorites';
import { SINGLE_CARD_FETCH_SUCCEEDED } from '../redux/singleCard';
import {
  EXPERIMENTS_SUCCEEDED,
  EXPERIMENTS_REQUEST_FAILED,
} from '../redux/experiments';
import {
  CARD_FILTER_MODAL_OPENED,
  CARD_FILTER_MODAL_CLOSED,
  FLYER_FILTER_MODAL_OPENED,
  FLYER_FILTER_MODAL_CLOSED,
} from '../redux/modals';
import {
  LINK_CLICKED,
  ELEMENT_CLICKED,
  ONBOARDING_CHANGED,
} from '../redux/tracking';
import { NAV_FINISHED } from '../redux/nav';
import { SEARCH_REQUESTED, SEARCH_COMPLETED } from '../redux/search';
import { SAVE_AND_NAVIGATE_TO_DELIVERY_SUCCEEDED } from '../redux/viewport';
import { TRAY_OPENED, TRAY_CLOSED } from '../redux/tray';

// Tracking IDs sent out
import { pbr_nav_finished } from '../tracking/nav.tracking';
import { pbr_single_card_fetch_succeeded } from '../tracking/singleCard.tracking';
import {
  pbr_select_sort,
  pbr_filters_opened,
  pbr_filters_finished,
  pbr_filters_opened_flyers,
  pbr_filters_finished_flyers,
  pbr_toggle_filter,
  pbr_toggle_filter_flyers,
} from '../tracking/filters.tracking';
import { pbr_ios_deep_link_clicked } from '../tracking/deepLinks.tracking';
import { pbr_email_design_requested } from '../tracking/emailDesign.tracking';
import {
  pbr_create_enter,
  pbr_send_succeeded,
} from '../tracking/event.tracking';

import {
  pbr_experiments_succeeded,
  pbr_experiments_request_failed,
} from '../tracking/experiments.tracking';
import { pbr_page_load } from '../tracking/location.tracking';
import { pbr_onboarding_changed } from '../tracking/onboarding.tracking';
import {
  pbr_link_clicked,
  pbr_element_clicked,
} from '../tracking/links.tracking';
import { pbr_add_favorite_success } from '../tracking/favorites.tracking';
import {
  pbr_sign_up_succeeded,
  pbr_log_in_succeeded,
  pbr_log_out_requested,
  pbr_reset_password_succeeded,
} from '../tracking/account.tracking';
import {
  pbr_search_requested,
  pbr_search_completed,
} from '../tracking/search.tracking';
import { pbr_tray_opened, pbr_tray_closed } from '../tracking/tray.tracking';

import { pbr_create_to_delivery } from '../tracking/viewport.tracking';

const mappedEvents = {};

mappedEvents[WINDOW_AVAILABLE] = pbr_page_load;
mappedEvents[ROUTER_LOCATION_CHANGED] = pbr_page_load;
mappedEvents[NAV_FINISHED] = pbr_nav_finished;
mappedEvents[DEEP_LINK_CLICKED] = pbr_ios_deep_link_clicked;
mappedEvents[EMAIL_DESIGN_REQUESTED] = pbr_email_design_requested;
mappedEvents[LINK_CLICKED] = pbr_link_clicked;
mappedEvents[ELEMENT_CLICKED] = pbr_element_clicked;
mappedEvents[EXPERIMENTS_SUCCEEDED] = pbr_experiments_succeeded;
mappedEvents[EXPERIMENTS_REQUEST_FAILED] = pbr_experiments_request_failed;
mappedEvents[LOG_OUT_REQUESTED] = pbr_log_out_requested;
mappedEvents[ONBOARDING_CHANGED] = pbr_onboarding_changed;
mappedEvents[RESET_PASSWORD_SUCCEEDED] = pbr_reset_password_succeeded;
mappedEvents[CARD_FILTER_MODAL_OPENED] = pbr_filters_opened;
mappedEvents[CARD_FILTER_MODAL_CLOSED] = pbr_filters_finished;
mappedEvents[FLYER_FILTER_MODAL_OPENED] = pbr_filters_opened_flyers;
mappedEvents[FLYER_FILTER_MODAL_CLOSED] = pbr_filters_finished_flyers;
mappedEvents[pbr_select_sort] = pbr_select_sort;
mappedEvents[pbr_toggle_filter] = pbr_toggle_filter;
mappedEvents[pbr_toggle_filter_flyers] = pbr_toggle_filter_flyers;
mappedEvents[SINGLE_CARD_FETCH_SUCCEEDED] = pbr_single_card_fetch_succeeded;
mappedEvents[ADD_FAVORITE_SUCCESS] = pbr_add_favorite_success;
mappedEvents[LOG_IN_SUCCEEDED] = pbr_log_in_succeeded;
mappedEvents[SIGN_UP_SUCCEEDED] = pbr_sign_up_succeeded;
mappedEvents[SAVE_AND_NAVIGATE_TO_DELIVERY_SUCCEEDED] = pbr_create_to_delivery;
mappedEvents[NEW_SUCCEEDED] = pbr_create_enter;
mappedEvents[SEND_SUCCEEDED] = pbr_send_succeeded;
mappedEvents[SEARCH_REQUESTED] = pbr_search_requested;
mappedEvents[SEARCH_COMPLETED] = pbr_search_completed;
mappedEvents[TRAY_OPENED] = pbr_tray_opened;
mappedEvents[TRAY_CLOSED] = pbr_tray_closed;

export default mappedEvents;
